import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import savLogo from '../assets/Savlogo.png';
import './AppDownloadPopup.css';

const AppDownloadPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the popup
    const hasSeenPopup = localStorage.getItem('savory-app-popup-dismissed');
    
    // Show popup after a short delay if not dismissed
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000); // 1 second delay after page load

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    // Store dismissal in localStorage
    localStorage.setItem('savory-app-popup-dismissed', 'true');
    
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  const handleDownload = () => {
    // Track download click (optional analytics)
    // You can add analytics tracking here
    window.open('https://apps.apple.com/es/app/savory-cook-and-save-recipes/id6749621956?l=en-GB', '_blank');
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="app-popup-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: isClosing ? 0 : 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        onClick={handleClose}
      >
        <motion.div
          className="app-popup-content"
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ 
            opacity: isClosing ? 0 : 1, 
            scale: isClosing ? 0.9 : 1,
            y: isClosing ? 20 : 0
          }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          onClick={(e) => e.stopPropagation()}
        >
          <button 
            className="app-popup-close"
            onClick={handleClose}
            aria-label="Close popup"
          >
            <span className="app-popup-close-icon">×</span>
          </button>

          <div className="app-popup-body">
            <div className="app-popup-icon">
              <img src={savLogo} alt="Savory Logo" className="app-popup-logo" />
            </div>

            <h2 className="app-popup-title">Try Savory on iOS</h2>
            <p className="app-popup-description">
              Download our mobile app for a better cooking experience. Save recipes, create meal plans, and cook with ease on the go.
            </p>

            <button 
              className="app-popup-button"
              onClick={handleDownload}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Download on App Store
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AppDownloadPopup;

